import { render, staticRenderFns } from "./AiPreviewSlideMenu.vue?vue&type=template&id=24d1758a&scoped=true"
import script from "./AiPreviewSlideMenu.vue?vue&type=script&lang=ts"
export * from "./AiPreviewSlideMenu.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AiPreviewSlideMenu.vue?vue&type=style&index=0&id=24d1758a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "24d1758a",
  null
  ,true
)

export default component.exports